import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/AboutUs.css";

const AboutUs = () => {
  const companyStats = [
    { value: "5+ Years", label: "Trusted Operations" },
    { value: "25+ Years", label: "Team Experience" },
    { value: "250,000 sq ft", label: "Managed Area" },
    { value: "500 MT", label: "Annual Movement" },
    { value: "50+ Staff", label: "Trained Workforce" },
  ];

  return (
    <section id="about-us" className="about-us-section">
      <Container>
        <h2 className="section-title">About Us</h2>

        <Row className="align-items-center mb-5">
          <Col md={12}>
            <p className="lead-text">
              <strong>PMJ Logistics Solutions LLP</strong> is a leading logistics and operations
              management company, delivering end-to-end supply chain solutions across India.
              Our commitment to precision, reliability, and innovation sets us apart in a rapidly
              evolving logistics landscape.
            </p>
            <p className="sub-text">
              Founded with a mission to transform the logistics experience, we streamline operations,
              reduce costs, and ensure timely deliveries—every single time. 5 years old logistics
              company based in Pune. Operations in Pune, Mumbai, Gujarat (Sanand), Telangana, AP,
              Chennai. Team with 25+ years experience. Managing 250,000 sq.ft. space & 500 MT annually.
              Expertise in Contract Logistics, Spare Parts Management, 3PL & 4PL, PAN-India Transport,
              LMD & Distribution. 50 trained staff with SAP, Tally & ERP Knowledge.
            </p>
          </Col>
        </Row>

        {/* Company Overview */}
        <div className="block">
          <h3 className="block-title">Company Overview</h3>
          <Row className="g-4 stats-row">
            {companyStats.map((s, i) => (
              <Col key={i} xs={12} sm={6} md={4} lg={3}>
                <div className="stat-card">
                  <div className="stat-value">{s.value}</div>
                  <div className="stat-label">{s.label}</div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default AboutUs;
